// extracted by mini-css-extract-plugin
export default {"table":"ExcelViewer_table__CeLZJ","thead_tr":"ExcelViewer_thead_tr__2vA6+","tbody_tr":"ExcelViewer_tbody_tr__wD1bO"};